// Copyright © 2022 Move Closer

export const YOUTUBE_REGEX = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch?))\??v?=?([^#&?"]*).*/
